
<div class="expiration-date-input" [formGroup]="formGroup">
    <input matInput type="number" class="month" formControlName="month" (input)="onChange(value)" autocomplete="off">
    <span class="separator">/</span>
    <input matInput type="number" class="year" formControlName="year" (input)="onChange(value)" autocomplete="off">
</div>
